import { scene } from '../../theme';
import { NeutralScene, StageScene, ViewportGrid as SharedViewportGrid } from '../shared/StageScene';

// ---------------------------------------------------------------------------
// Scene presets. The viewer's job is to show the asset the way we'd render
// it in-game — same lighting, same colors — on a neutral stage. Trunks /
// branches / segment-local geometry are explicitly out of scope; the stage
// is asset-on-stage, not asset-in-world.
//
// The grid is intentionally NOT part of any preset — it's a separate
// inspector toggle (see ViewportGrid below). Lets you check size on either
// preset without having to switch lighting.
//
// Stage / Neutral / Grid components were promoted to
// client/src/tools/shared/StageScene.tsx so the trees viewer can reuse
// them. We re-export ViewportGrid from here so existing imports keep
// working.
//
// Adding a new preset is a one-file change — append to `scenePresets`.
// ---------------------------------------------------------------------------

export interface ScenePreset {
  id: string;
  name: string;
  description: string;
  /** Background color for the R3F Canvas. */
  background: string;
  /** R3F nodes rendered into the viewport BEFORE the asset. */
  render: () => React.ReactElement;
}

export const scenePresets: readonly ScenePreset[] = [
  {
    id: 'stage',
    name: 'Stage',
    description: 'In-game lighting + ground plane. The "what does it look like in Heartwood" preset.',
    background: scene.sky,
    render: () => <StageScene />,
  },
  {
    id: 'neutral',
    name: 'Neutral',
    description: 'Flat lighting on a mid-gray background, no ground. Material QA.',
    background: '#3a3a3a',
    render: () => <NeutralScene />,
  },
];

export function findPreset(id: string): ScenePreset | undefined {
  return scenePresets.find(p => p.id === id);
}

export const ViewportGrid = SharedViewportGrid;
